import { render, staticRenderFns } from "./ShippingOfflineLocations.vue?vue&type=template&id=135d589a&scoped=true"
import script from "./ShippingOfflineLocations.vue?vue&type=script&lang=js"
export * from "./ShippingOfflineLocations.vue?vue&type=script&lang=js"
import style0 from "./ShippingOfflineLocations.vue?vue&type=style&index=0&id=135d589a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135d589a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})
